import React from 'react';
import BaseSimplePage from "../BaseSimplePage/BaseSimplePage";
import SchoolSubjectsItemForm from "./SchoolSubjectsItemForm";

const SchoolSubjectsPage = ({isAddSubMode}) => {

    return (
        <BaseSimplePage
            isAddSubMode={isAddSubMode}
            modeApiName1="school_subject"
            modeApiName2="school_subjects"
            ItemFormComponent={SchoolSubjectsItemForm}
        />
    );
};

export default SchoolSubjectsPage;